/* eslint-disable react/prop-types */
import React, { InputHTMLAttributes, forwardRef } from 'react'

import './styles.scss'

type TextFieldProps = {
  isError?: boolean
  errorMsg?: string
  label?: string
  wrapperClass?: string
  inputClass?: string
  variant?: 'standard' | 'filled' | 'outlined'
  inputComponent?: React.ReactElement
} & InputHTMLAttributes<HTMLInputElement>

const TextField = forwardRef<HTMLInputElement, TextFieldProps>((props, ref) => {
  const { inputComponent } = props
  return (
    <div
      className={`text-field-wrapper ${props.variant ?? 'standard'} ${!!props.value ? 'has-value' : ''} ${
        props.wrapperClass || ''
      }`}
    >
      <label className="label">{props.label}</label>
      <div className={`text-field-group ${props.variant ?? 'standard'} ${props.isError ? 'input-error' : ''}`}>
        {inputComponent ? (
          inputComponent
        ) : (
          <input
            ref={ref}
            className={`text-field ${props.inputClass || ''}`}
            id={props.id}
            name={props.name}
            value={props.value}
            type={props.type}
            placeholder={props.placeholder}
            onChange={props.onChange}
            onBlur={props.onBlur}
          />
        )}
      </div>
      {props.isError ? (
        <div className="error-helper">{props.errorMsg}</div>
      ) : (
        <div className="error-helper">&nbsp;</div>
      )}
    </div>
  )
})

TextField.displayName = 'TextField'

export default TextField
